module.exports = __webpack_public_path__ + "static/media/23a.fa66df40.jpg";